import React from 'react';
import { 
  User, 
  Scale, 
  Clock, 
  RefreshCw, 
  CheckCircle2, 
  MessageSquareMore 
} from 'lucide-react';

const SupportEmptyState = ({ activeTab }) => {
  const getEmptyStateConfig = () => {
    switch (activeTab) {
      case 'my':
        return {
          icon: User,
          title: 'No tickets created by you',
          message: 'Click the + icon to create your first support ticket.',
        };
      case 'involved':
        return {
          icon: Scale,
          title: 'No dispute tickets',
          message: 'You\'re not involved in any dispute tickets.',
        };
      case 'open':
        return {
          icon: Clock,
          title: 'No open tickets',
          message: 'No open support tickets found.',
        };
      case 'in_progress':
        return {
          icon: RefreshCw,
          title: 'No in-progress tickets',
          message: 'No tickets are currently in progress.',
        };
      case 'resolved':
        return {
          icon: CheckCircle2,
          title: 'No resolved tickets',
          message: 'You don\'t have any resolved tickets yet.',
        };
      default:
        return {
          icon: MessageSquareMore,
          title: 'No support tickets',
          message: 'Click the + icon to create your first support ticket.',
        };
    }
  };

  const config = getEmptyStateConfig();
  const Icon = config.icon;

  return (
    <div className="flex flex-col items-center justify-center px-8 py-20 text-center">
      <div className="w-24 h-24 rounded-full bg-gray-50 flex items-center justify-center mb-6">
        <Icon size={48} className="text-gray-300" />
      </div>
      
      <h3 className="text-xl font-bold text-gray-900 mb-3">
        {config.title}
      </h3>
      
      <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
        {config.message}
      </p>
    </div>
  );
};

export default SupportEmptyState;